export type LRP = {
    PositionLon: number;
    PositionLat: number;
    FRC: number;
    FOW: number;
    LFRCNP: number;
    Bear: number;
    DistanceToNext: number;
}

export type OpenLRDecodeResult = {
    Header: number;
StartLocation: LRP;
MidLocation: LRP[];
EndLocation: LRP;
PosOffset: number;
NegOffset: number;
}

export class OpenLRDecoder {

    public static decode(encodedData: string): OpenLRDecodeResult {
        let count = 1;
      
        // 解碼 base64 字串
        const binaryString = atob(encodedData);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
      
        // 輔助函式：從 Uint8Array 讀取 24 位整數
        function read24BitInt(array: Uint8Array, offset: number): number {            
          return (array[offset] << 16) | (array[offset + 1] << 8) | array[offset + 2];
        }
      
        // 輔助函式：從 Uint8Array 讀取 16 位帶符號整數
        function read16BitSignedInt(array: Uint8Array, offset: number): number {
          const value = (array[offset] << 8) | array[offset + 1];
          return value & 0x8000 ? value - 0x10000 : value;
        }
      
        // 輔助函式：從整數解碼經緯度
        function decodeCoordinate(integerDegree: number) {
          return ((integerDegree - 0.5) * 360) / Math.pow(2, 24);
        }
      
        // 解析 LRP1
        function decodeLRP1(array: Uint8Array, offset: number) {
          const lon_originValue = read24BitInt(array, offset);
          const lat_originValue = read24BitInt(array, offset + 3);
        //   console.log(`正在解析第 ${count++} 個 LRP：`);
        //   console.log("lon_originValue:", lon_originValue);
        //   console.log("lat_originValue:", lat_originValue);
      
          const lon = decodeCoordinate(read24BitInt(array, offset));
          const lat = decodeCoordinate(read24BitInt(array, offset + 3));
          const attr1 = array[offset + 6];
          const attr2 = array[offset + 7];
          const attr3 = array[offset + 8];
          const attr4 = array[offset + 9];
      
          return {
            PositionLon: lon,
            PositionLat: lat,
            FRC: attr1 >> 3,
            FOW: attr1 & 0x07,
            LFRCNP: attr2 >> 5,
            Bear: (attr2 & 0x1f) * 11.25, // 轉換為度數
            DistanceToNext: (attr3 << 8) | attr4,
          };
        }
      
        // 解析 LRP2+
        function decodeLRP2Plus(array: Uint8Array, offset: number, prevLon: number, prevLat: number) {
          const lon_originValue = read16BitSignedInt(array, offset);
          const lat_originValue = read16BitSignedInt(array, offset + 2);
        //   console.log(`正在解析第 ${count++} 個 LRP：`);
        //   console.log("lon_originValue:", lon_originValue);
        //   console.log("lat_originValue:", lat_originValue);
      
          const lonOffset = read16BitSignedInt(array, offset);
          const latOffset = read16BitSignedInt(array, offset + 2);
          const lon = prevLon + lonOffset * 0.00001; // 調整為適當的比例
          const lat = prevLat + latOffset * 0.00001; // 調整為適當的比例
          const attr1 = array[offset + 4];
          const attr2 = array[offset + 5];
          const attr3 = array[offset + 6];
          const attr4 = array[offset + 7];
      
          return {
            PositionLon: lon,
            PositionLat: lat,
            FRC: attr1 >> 3,
            FOW: attr1 & 0x07,
            LFRCNP: attr2 >> 5,
            Bear: (attr2 & 0x1f) * 11.25, // 轉換為度數
            DistanceToNext: (attr3 << 8) | attr4,
          };
        }
      
        // 解析 header
        const header = bytes[0];
      
        // 解析第一個 LRP
        const startLRP = decodeLRP1(bytes, 1);
      
        const numIntermediateLRPs = Math.floor((bytes.length - 18) / 7); // 18 = 1(header) + 9(first LRP) + 6(last LRP) + 2(offsets)
        const intermediateLRPs = [];
        let prevLon = startLRP.PositionLon;
        let prevLat = startLRP.PositionLat;
      
        for (let i = 0; i < numIntermediateLRPs; i++) {
          const lrp = decodeLRP2Plus(bytes, 10 + i * 7, prevLon, prevLat);
          intermediateLRPs.push(lrp);
          prevLon = lrp.PositionLon;
          prevLat = lrp.PositionLat;
        }
      
        const lastLRPOffset = 10 + numIntermediateLRPs * 7;
        const endLRP = decodeLRP2Plus(bytes, lastLRPOffset, prevLon, prevLat);
      
        // 解析 offsets
        const posOffset = bytes[bytes.length - 2];
        const negOffset = bytes[bytes.length - 1];
      
        return {
          Header: header,
          StartLocation: startLRP,
          MidLocation: intermediateLRPs,
          EndLocation: endLRP,
          PosOffset: posOffset,
          NegOffset: negOffset,
        };
      }
}